import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { alpha, useTheme } from "@mui/material/styles";
import { printPedidoCompraPdf } from "../../utils/printPedidoCompraPdf";

/**
 * Botón para imprimir / descargar PDF del pedido de compra A3 (proveedor + matriz).
 */
export default function PedidoCompraPrint({ row, size = "small", sx = {} }) {
  const theme = useTheme();
  const [busy, setBusy] = useState(false);
  const canPrint = row?.IdPedc != null && Number(row.IdPedc) > 0;

  const handlePrint = async (e) => {
    e?.stopPropagation?.();
    if (!canPrint || busy) return;
    setBusy(true);
    try {
      await printPedidoCompraPdf(row);
    } catch (err) {
      console.error("[PedidoCompraPrint]", err);
      window.alert(
        err?.message ||
          "No se pudo generar el PDF del pedido de compra. Comprueba que el pedido existe en A3.",
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <Tooltip
      title={
        canPrint
          ? "Imprimir pedido de compra (PDF)"
          : "Sin pedido de compra en A3"
      }
    >
      <span>
        <IconButton
          size={size}
          onClick={handlePrint}
          disabled={!canPrint || busy}
          sx={{
            ml: 0.5,
            p: 0.45,
            color: "error.main",
            border: "1px solid",
            borderColor: "error.main",
            borderRadius: 1,
            backgroundColor: alpha(theme.palette.error.main, 0.06),
            "&:hover": {
              backgroundColor: alpha(theme.palette.error.main, 0.14),
            },
            ...sx,
          }}
          aria-label="Imprimir pedido de compra"
        >
          {busy ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <LocalPrintshopOutlinedIcon sx={{ fontSize: "1rem" }} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
}
